import { ChangeDetectorRef, Directive, ElementRef, HostListener, Injector, Optional } from '@angular/core';
import { FormGroupDirective, NgForm, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ValueAccessor } from './value-accessor';

/* tslint:disable:directive-selector */
@Directive({
    selector: 'anj-radio-group, anj-select, anj-type-ahead',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SelectValueDirective,
            multi: true
        }
    ]
})
export class SelectValueDirective extends ValueAccessor {
    constructor(@Optional() parentForm: NgForm,
                @Optional() parentFormGroup: FormGroupDirective,
                element: ElementRef,
                injector: Injector,
                changeRef: ChangeDetectorRef) {
        super(element, parentForm, parentFormGroup, injector, changeRef);
    }

    @HostListener('anjChange', ['$event.target'])
    public onAnjChange(target: HTMLInputElement) {
        // ignore the input for type-aheads
        if (target.matches('anj-input')) {
            return;
        }

        this.onChangeEvent(target.value);
    }
}
